// extracted by mini-css-extract-plugin
export var formContainer = "_jk-0";
export var message = "_jk-1";